<script>
import ReportManagerDialogVue from 'Support/components/modals/ReportManagerDialog.vue';
import LotesPurchaseRequest from 'Domain/financial/LotesPurchaseRequest';

export default {
  name: 'LoansTerminateButton',
  extends: ReportManagerDialogVue,
  data: () => ({
    requestClass: LotesPurchaseRequest,
    buttonLabel: 'Download empréstimo',
    tableName: 'LotesPurchaseList',
  }),
  methods: {
    proxyRequest(params = {}) {
      return this.requestClass.downloadLoans(params);
    },
  },
};
</script>
